/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GoalEventCreate = {
    properties: {
        minute: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
        },
        teamId: {
            type: 'number',
            isRequired: true,
        },
        externalId: {
            type: 'any-of',
            contains: [{
                type: 'string',
            }, {
                type: 'null',
            }],
        },
        assistId: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
        },
        goalTypeKey: {
            type: 'any-of',
            contains: [{
                type: 'GoalTypeEnum',
            }, {
                type: 'null',
            }],
        },
        goal1: {
            type: 'number',
            isRequired: true,
        },
        goal2: {
            type: 'number',
            isRequired: true,
        },
        playerId: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
        },
    },
} as const;
